<div class="grid">
    <div class="col-12">
        <form>
            <p-card header="New Payment Verification">
                <p-messages [(value)]="messages" [closable]="true" />
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="username" class="text-sm text-500"
                            >Payment Reference</label
                        >
                        <input
                            type="text"
                            id="username"
                            placeholder="Payment Reference"
                            pInputText
                            formControlName="username"
                        />
                    </div>
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="firstname" class="text-sm text-500"
                            >Payment Date</label
                        >
                        <span class="p-input-icon-left">
                            <p-calendar
                                id="dob"
                                [showIcon]="true"
                                [iconDisplay]="'input'"
                                formControlName="dateOfBirth"
                                placeholder="Select Payment Date"
                                styleClass="w-full p-input-icon-left"
                                [inputStyle]="{ paddingLeft: '2.5rem' }"
                                inputStyleClass="w-full"
                            ></p-calendar>
                        </span>
                    </div>
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="surname" class="text-sm text-500"
                            >Additional Notes</label
                        >
                        <input
                            type="text"
                            id="surname"
                            placeholder="Additional Notes"
                            pInputText
                            formControlName="lastName"
                        />
                    </div>
                    
                </div>
                <ng-template class="align-items-right" pTemplate="footer">
                    <div class="flex gap-2">
                        <p-button
                            icon="pi pi-times-circle"
                            pRipple
                            label="Clear"
                            severity="secondary"
                        />

                        <button
                            icon="pi pi-check"
                            label="Submit"
                            severity="primary"
                            pTooltip="Add new user"
                            pButton
                            pRipple
                        ></button>
                    </div>
                </ng-template>
            </p-card>
        </form>
    </div>
</div>
